var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIdCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_72",
    "data-name": "Group 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.224,
    height: 14.556,
    viewBox: "0 0 14.224 14.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M9.861,0a3.016,3.016,0,0,1,2.232,5.135Q10.116,7.121,8.132,9.1a6.2,6.2,0,0,1-3.4,1.732c-.664.118-1.324.259-1.985.389a.824.824,0,0,1-1-1.012c.18-.89.342-1.784.552-2.668A5.391,5.391,0,0,1,3.726,4.973Q5.793,2.874,7.889.8A2.843,2.843,0,0,1,9.861,0M3.615,9.358c.265-.052.5-.1.738-.141A4.6,4.6,0,0,0,6.941,7.948Q8.912,5.971,10.887,4A1.363,1.363,0,1,0,8.964,2.069C7.645,3.381,6.338,4.705,5.013,6.012a5.435,5.435,0,0,0-1.4,3.346",
    transform: "translate(-0.353 0)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M7.107,17.886q-3.1,0-6.2,0a.815.815,0,0,1-.876-.6.814.814,0,0,1,.734-1.046c.055,0,.11,0,.165,0q6.19,0,12.381,0a.833.833,0,0,1,.835.49.819.819,0,0,1-.756,1.163c-.964.008-1.929,0-2.893,0H7.107",
    transform: "translate(0.001 -3.332)",
    fill: "#0a64f9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIdCard);
export default __webpack_public_path__ + "static/media/editIdCard.89325cd61f3a751b31e7258c6886987c.svg";
export { ForwardRef as ReactComponent };